<div class="d-flex flex-column justify-content-around align-items-center user-idle">
    <div class='title'>
        <h1>{{ 'IDLE.STILL_THERE' | translate | uppercase }}</h1>
    </div>
    <app-circle-progress [span]="30" [progress]="countdown" [message]="'IDLE.NAVIGATING'"></app-circle-progress>
    <button (click)="restartIdle()" class="btn-rug confirm-button">{{ 'IDLE.I_AM_HERE' | translate | uppercase }}</button>
    <img class="decoration-path" src="assets/img/path.svg" alt="path"/>
</div>
